import { render, staticRenderFns } from "./awardConfig.vue?vue&type=template&id=475fc2c6&scoped=true&"
import script from "./awardConfig.vue?vue&type=script&lang=ts&"
export * from "./awardConfig.vue?vue&type=script&lang=ts&"
import style0 from "./awardConfig.vue?vue&type=style&index=0&id=475fc2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fc2c6",
  null
  
)

export default component.exports